export default [
  {
    path: '/evaluationNot',
    name: 'evaluationNot',
    meta: { login: false, title:'职业测评' },
    component: () => import(/* webpackChunkName: 'evaluationNot' */ './page/evaluationNot.vue'),
  },
  {
    path: '/evaluationAlready',
    name: 'evaluationAlready',
    meta: { login: true, title:'职业测评' },
    component: () => import(/* webpackChunkName: 'evaluationAlready' */ './page/evaluationAlready.vue'),
  },
  // {
  //       path: '/',
  //       redirect: '/junmin_homepage',
  //       // name: 'sdjz_homepage',
  //       // component: () => import(/* webpackChunkName: 'education' */ './page/sdjzHomepage.vue'),
  // },
]